import { render, staticRenderFns } from "./MockScore.vue?vue&type=template&id=d8bd908a&scoped=true"
import script from "./MockScore.vue?vue&type=script&lang=js"
export * from "./MockScore.vue?vue&type=script&lang=js"
import style0 from "./MockScore.vue?vue&type=style&index=0&id=d8bd908a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8bd908a",
  null
  
)

export default component.exports